export var BANNER_TYPE = {
  YOU_MIGHT_LIKE: 'YOU_MIGHT_LIKE',
  NOW_TRENDING: 'NOW_TRENDING'
};